module.exports = __webpack_public_path__ + "img/evolucao cidade.6c09f2c2.png";